import { render, staticRenderFns } from "./BorrowerGift.vue?vue&type=template&id=2c1f98c4&scoped=true&"
import script from "./BorrowerGift.vue?vue&type=script&lang=js&"
export * from "./BorrowerGift.vue?vue&type=script&lang=js&"
import style0 from "./BorrowerGift.vue?vue&type=style&index=0&id=2c1f98c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1f98c4",
  null
  
)

export default component.exports